import { RUPEE } from "../constant";

function convertToRupees(amount, rounded = false) {
    
    const parsedAmount = parseFloat(amount);

    if (!isNaN(parsedAmount)) {
        if (rounded) {
            const roundedAmount = Math.round(parsedAmount);
            return RUPEE + roundedAmount.toLocaleString('en-IN');
        } else {
            const roundedAmount = parseFloat(parsedAmount.toFixed(2));
            const isWholeNumber = roundedAmount % 1 === 0;
            if (isWholeNumber) {
                return RUPEE + roundedAmount.toLocaleString('en-IN');
            } else {
                return RUPEE + roundedAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        }
    } else {
        return RUPEE + '0.00';
    }
}

export default convertToRupees;

